import { UniversalConfig } from '@application/universal_config.service';
import { AspectRatio } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { useResolve } from '@visiba/instantiation';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface Props {
	size?: 'small' | 'medium' | 'large';
	onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

export function Logo({ size = 'medium', onClick }: Props) {
	const universalConfig = useResolve(UniversalConfig);

	let width: number;
	switch (size) {
		case 'small':
			width = 48;
			break;
		case 'medium':
			width = 96;
			break;
		case 'large':
			width = 128;
			break;
	}

	return (
		<StyledLink to='/' onClick={onClick}>
			<span
				style={{
					display: 'block',
					width: width,
				}}
			>
				<AspectRatio.Root ratio={2}>
					<AspectRatio.Img
						src={universalConfig.logo}
						alt=''
						style={{
							objectFit: 'contain',
							width: '100%',
							height: '100%',
						}}
					/>
				</AspectRatio.Root>
			</span>
		</StyledLink>
	);
}

const StyledLink = styled(Link)`
	padding: 2px;

	&:focus-visible {
		outline: 2px solid ${tokens.color.focus};
		outline-offset: -2px;
		border-radius: ${tokens.borderRadius.small};
	}
`;
